import { typeProductStock } from "./productStock"
import { queryProductStock } from "./queries/queryProductStock"
import { queryProductStocks } from "./queries/queryProductStocks"

const productStockSchema = {
  types: [typeProductStock],
  resolvers: {
    Query: { ...queryProductStock, ...queryProductStocks },
    Mutation: {},
  },
}

export default productStockSchema
